import type { DateEventColor } from "@bedrock/domain";

export const DATE_EVENT_COLORS = [
  { value: "lilac", label: "Lilac" },
  { value: "sky", label: "Sky" },
  { value: "mint", label: "Mint" },
  { value: "butter", label: "Butter" },
  { value: "peach", label: "Peach" },
  { value: "rose", label: "Rose" }
] as const satisfies ReadonlyArray<{ value: DateEventColor; label: string }>;

export function dateEventColorLabel(color: DateEventColor): string {
  return DATE_EVENT_COLORS.find((option) => option.value === color)?.label ?? "Lilac";
}
